skrilla.controller('affiliateDetailsCtrl', function ($scope, searchService, $stateParams, validationService, modalService) {
    $scope.key = "affiliateDetails";
    var validation = validationService;

    $scope.validate = {}

    $scope.tabs = [
        {title: "Details", active: true},
        {title: "Notes", active: false},
        {title: "Claims", active: false}
    ];

    if($stateParams.transactionHash){
        $scope.selected = 1;
    }

    $scope.search = function(){
        searchService.get("affiliates/" + $stateParams.id).then(function(response){
            $scope.affiliate = response.data;
        })
    }
    $scope.search();

    $scope.update = function(){
        if(validate()){
            modalService.confirm("Are you sure you'd like to update this affiliate?", function(){
                searchService.put("affiliates/" + $scope.affiliate.id, $scope.affiliate, "Affiliate successfully updated").then(function(response){
                    $scope.search();
                });
            });
        }
    }

    function validate(){
        var inputs = [
            validation.buildFieldValidationObj("name", !validation.isEmpty($scope.affiliate.name), "Please enter a name"),
            validation.buildFieldValidationObj("email", validation.isEmail($scope.affiliate.email), "Please enter a valid email"),
        ];
        return validation.validateForm(inputs, $scope.validate)
    }

});